import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Demo from "@/pages/Demo";
import { Login, Register } from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Goals from "@/pages/Goals";
import MealPlan from "@/pages/MealPlan";
import RecipeDetail from "@/pages/RecipeDetail";
import Settings from "@/pages/Settings";
import Pricing from "@/pages/Pricing";
import Grocery from "@/pages/Grocery";
import Household from "@/pages/Household";
import Recipes from "@/pages/Recipes";
import ShareView from "@/pages/ShareView";
import Admin from "@/pages/Admin";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import DeleteAccount from "@/pages/DeleteAccount";
import LegalPage from "@/pages/LegalPage";
import Support from "@/pages/Support";
import Journal from "@/pages/Journal";
import { PRIVACY_PUBLISHED, TERMS_PUBLISHED } from "@/i18n/legal";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=") && location.pathname !== "/delete-account") return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Demo />} />
      <Route path="/demo" element={<Demo />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/share/:token" element={<ShareView />} />
      <Route path="/delete-account" element={<DeleteAccount />} />
      <Route path="/support" element={<Support />} />
      {PRIVACY_PUBLISHED && <Route path="/privacy" element={<LegalPage kind="privacy" />} />}
      {TERMS_PUBLISHED && <Route path="/terms" element={<LegalPage kind="terms" />} />}
      <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/goals" element={<ProtectedRoute><Goals /></ProtectedRoute>} />
      <Route path="/meal-plan" element={<ProtectedRoute><MealPlan /></ProtectedRoute>} />
      <Route path="/journal" element={<ProtectedRoute><Journal /></ProtectedRoute>} />
      <Route path="/grocery" element={<ProtectedRoute><Grocery /></ProtectedRoute>} />
      <Route path="/household" element={<ProtectedRoute><Household /></ProtectedRoute>} />
      <Route path="/recipes" element={<ProtectedRoute><Recipes /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
      <Route path="/pricing" element={<ProtectedRoute><Pricing /></ProtectedRoute>} />
      <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
      <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
      <Route path="/recipe/:id" element={<ProtectedRoute><RecipeDetail /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <AppRouter />
            <Toaster position="top-center" richColors />
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}
